import {
    Button,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    Select,
} from '@/platform/ui';
import { TrashIcon } from '@heroicons/react/24/outline';

const YearValue = ({ child, sectorOptions, errors, onChange, onDelete }) => (
    <Segment>
        <SegmentContent>
            <div className='grid grid-cols-[1fr_auto] items-end gap-4'>
                <FormGroup inline equal>
                    <Input
                        label='Jaar'
                        type='number'
                        required
                        value={child?.year || ''}
                        onChange={event =>
                            onChange(child.key, 'year', event.target.value)
                        }
                        error={errors?.year}
                    />
                    <Select
                        label='Sector'
                        placeholder='Geen sector'
                        options={sectorOptions}
                        value={child?.sector_id || ''}
                        onChange={event =>
                            onChange(child.key, 'sector_id', event.target.value)
                        }
                        error={errors?.sector_id}
                    />
                    <Input
                        label='Waarde'
                        value={child?.value || ''}
                        onChange={event =>
                            onChange(child.key, 'value', event.target.value)
                        }
                        error={errors?.value}
                    />
                </FormGroup>
                <Button
                    variant='danger'
                    type='button'
                    onClick={() => onDelete(child.key)}
                    aria-label={`Verwijder jaarwaarde ${child?.year || ''}`}
                >
                    <TrashIcon className='size-5' />
                </Button>
            </div>
        </SegmentContent>
    </Segment>
);

export default YearValue;
